/**
 * Enum which describes the tabs on Search results
 * These should always be in the order of tabs being shown
 */
export enum SearchResultsTab {
    Mail,
    People,
    Events,
}
